<template>
  <section>
    <div class="row">
      <div class="offset-xl-1 offset-lg-0 offset-md-0 offset-sm-0"></div>
      <div class="col-xl-9 col-12">
        <h4>E-Mail Warteschlange</h4>
      </div>
    </div>
    <div class="row">
      <div class="offset-xl-3 offset-lg-0 offset-md-0 offset-sm-0"></div>
      <div class="col-xl-2 col-lg-4 col-md-6 col-sm-12">
        <dashboard-info-card
          id="Mail Mitglieder"
          title="Mail Mitglieder"
          :value="mailCustomer"
        >
        </dashboard-info-card>
      </div>
      <div class="col-xl-2 col-lg-4 col-md-6 col-sm-12">
        <dashboard-info-card
          id="Mail Rundmail"
          title="Mail Rundmail"
          :value="mailCircular"
        >
        </dashboard-info-card>
      </div>
      <div class="col-xl-2 col-lg-4 col-md-6 col-sm-12">
        <dashboard-info-card
          id="Mail Benachrichtigungen"
          title="Mail Benachrichtigungen"
          :value="mailNotification"
        >
        </dashboard-info-card>
      </div>
      <div class="offset-xl-3 offset-lg-0 offset-md-0 offset-sm-0"></div>
    </div>
    <div class="row">
      <div class="offset-xl-3 offset-lg-0 offset-md-0 offset-sm-0"></div>
      <div class="col-xl-2 col-lg-4 col-md-6 col-sm-12">
        <dashboard-info-card
          id="Mail Bezahlung"
          title="Mail Bezahlung"
          :value="mailPayment"
        ></dashboard-info-card>
      </div>
      <div class="col-xl-2 col-lg-4 col-md-6 col-sm-12">
        <dashboard-info-card
          id="Mail Support"
          title="Mail Support"
          :value="mailSupport"
        ></dashboard-info-card>
      </div>
      <div class="col-xl-2 col-lg-4 col-md-6 col-sm-12">
        <dashboard-info-card
          id="Mail Admin"
          title="Mail Admin"
          :value="mailAdmin"
        ></dashboard-info-card>
      </div>
      <div class="offset-xl-3 offset-lg-0 offset-md-0 offset-sm-0"></div>
    </div>
  </section>
</template>

<script>
import DashboardInfoCard from "src/components/UIComponents/Cards/DashboardInfoCard";
export default {
  components: {
    DashboardInfoCard
  },
  data() {
    return {
      canFetch: true,
      mailAdmin: 0,
      mailNotification: 0,
      mailPayment: 0,
      mailCustomer: 0,
      mailCircular: 0,
      mailSupport: 0
    };
  },
  methods: {
    getQueueStats() {
      return this.$http
        .get("/api/v1/superadminDashboard/queueSize")
        .then(({ data }) => {
          this.mailAdmin = data["Mail Admin"];
          this.mailNotification = data["Mail Benachrichtigungen"];
          this.mailPayment = data["Mail Bezahlung"];
          this.mailCustomer = data["Mail Mitglieder"];
          this.mailCircular = data["Mail Rundmail"];
          this.mailSupport = data["Mail Support"];
        });
    },
    fetchData() {
      if (this.canFetch) {
        this.canFetch = false;
        return Promise.all([this.getQueueStats()]).finally(
          () => (this.canFetch = true)
        );
      }
    }
  },
  created() {
    this.fetchData();
    this.fetchInterval = setInterval(() => {
      this.fetchData();
    }, 3500);
    this.reloadTimeout = setTimeout(() => {
      location.reload(true);
    }, 300000);
  },
  beforeDestroy() {
    this.canFetch = false;
    clearTimeout(this.reloadTimeout);
    clearInterval(this.fetchInterval);
  }
};
</script>
